import { i18n } from "../../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import Button from '../../components/Button'
import Card from '../../components/Card'
import ContentLayout from '../../components/ContentLayout'
import ContentMain from '../../components/ContentMain'
import HeadingRow from '../../components/HeadingRow'
import Select, { SelectOption } from '../../components/Select'
import routes from '../../routes/routes'
import ConsumedCasesPaginate from './ConsumedCases/ConsumedCases'
import StandaloneCasesPaginate from './StandaloneCases/StandaloneCases'

type Type = 'standaloneCases' | 'consumedCases'

const types: SelectOption[] = [
  { name: 'Standalone cases', value: 'standaloneCases' },
  { name: 'Consumed cases', value: 'consumedCases' }
]

interface Props extends RouteComponentProps {}

interface State {
  type: Type
}

class StandaloneCases extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      type: 'standaloneCases'
    }
    this.handleCreateClick = this.handleCreateClick.bind(this)
    this.handleTypeChange = this.handleTypeChange.bind(this)
  }

  get paginate () {
    switch (this.state.type) {
      case 'standaloneCases':
        return <StandaloneCasesPaginate />
      case 'consumedCases':
        return <ConsumedCasesPaginate />
    }
  }

  handleCreateClick () {
    this.props.history.push(routes.standaloneCaseCreate)
  }

  handleTypeChange (name: string, value: string) {
    this.setState({ type: value as Type })
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="full">
          <Card>
            <HeadingRow
              heading={i18n("Standalone Cases")}
              doc='cases-view-all-standalone-cases'>
              <Button
                text={i18n("Create")}
                onClick={this.handleCreateClick} />
            </HeadingRow>
            <div className="grid lg:grid-cols-5">
              <Select
                name="type"
                value={this.state.type}
                options={types}
                onChange={this.handleTypeChange} />
            </div>
            {this.paginate}
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

export default withRouter(StandaloneCases)
